import { render, staticRenderFns } from "./warehouse2.vue?vue&type=template&id=c17220fa&scoped=true&"
import script from "./warehouse2.vue?vue&type=script&lang=js&"
export * from "./warehouse2.vue?vue&type=script&lang=js&"
import style0 from "./warehouse2.vue?vue&type=style&index=0&id=c17220fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17220fa",
  null
  
)

export default component.exports